import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Router } from "@angular/router";
import { FikoYTService } from "@/src/service/fikoyt.service";

export const uyelerGiremezGuard = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const fikoytService = inject(FikoYTService);
    const router = inject(Router);

    if (fikoytService.kimlik.aktifKullaniciJson()) {
        return false;
    }

    return true;
};

export const uyeOlmayanGiremezGuard = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const fikoytService = inject(FikoYTService);
    const router = inject(Router);

    if (!fikoytService.kimlik.aktifKullaniciJson()) {
        return router.createUrlTree(['/giris'], {
            queryParams: { sonraki: state.url }
        });
    }
    return true;
};